import { SafeAreaContent } from "@/components/content/safe-area-content";
import { isDashboardMealRecommendationsEnabled } from "@/constants/feature-flags";
import { OnPlanProgressBar } from "@/features/overview/components/on-plan-progress-bar";
import { OurProteinFavouritesPlanList } from "@/features/overview/components/our-protein-favourites-plan-list";
import { OverviewGreetingHeader } from "@/features/overview/components/overview-greeting-header";
import { OverviewWeightCard } from "@/features/overview/components/overview-weight-card";
import { PlanStatusCircle } from "@/features/overview/components/on-plan-status";
import { PopularOnPlanList } from "@/features/overview/components/popular-on-plan-list";
import { ThisWeekNutritionCard } from "@/features/overview/components/this-week-nutrition-card";
import { getProgressBreakpointsForRange } from "@/features/overview/constants/calorie-balance";
import { useGetCalorieDeviation } from "@/hooks/requests/balance/use-get-calorie-deviation";
import { cn } from "@/utils/cn";
import { IonPage } from "@ionic/react";
import { CSSProperties, memo } from "react";
import { ScienceBackedMessage } from "../../components";

export const OnPlanOverviewHomePage = memo(function OnPlanOverviewHomePage() {
  const { calorieDeviation, isLoading: isBalanceLoading } = useGetCalorieDeviation();
  const showMealRecommendations = isDashboardMealRecommendationsEnabled();
  const deviationValue = calorieDeviation?.totalCalorieDeviation;
  const dailyDeviationValue = calorieDeviation?.dailyCalorieDeviation;

  const breakpoints = getProgressBreakpointsForRange("week");
  const safeDeviationValue = deviationValue ?? 0;

  return (
    <IonPage
      style={{
        background:
          "linear-gradient(180deg, var(--color-violet-950) 0%, var(--color-dashboard-purple) 100%)",
      }}
    >
      <SafeAreaContent
        fullscreen
        scrollY={false}
        className="text-white"
        style={{ "--background": "transparent" } as CSSProperties}
      >
        <div className="mx-auto h-full max-w-[450px]">
          <div
            className={cn(
              "no-scrollbar flex h-full flex-col gap-4.5 overflow-y-auto px-4 text-white",
              "pb-[calc(var(--safe-area-inset-bottom)+7rem)]",
              "pt-[calc(var(--safe-area-inset-top)+1rem)]",
            )}
          >
            <div className="flex flex-col px-5 pt-6">
              <OverviewGreetingHeader />

              <div className="mt-[89px]">
                <PlanStatusCircle
                  value={safeDeviationValue}
                  dailyValue={dailyDeviationValue}
                  selectedRange={"week"}
                  isLoading={isBalanceLoading}
                />
              </div>

              <div className="mt-[67px]">
                <OnPlanProgressBar
                  value={safeDeviationValue}
                  breakpoints={breakpoints}
                  isLoading={isBalanceLoading}
                />
              </div>

              <div className="-mx-5 mt-[63px]">
                <ThisWeekNutritionCard />
              </div>
            </div>

            <div className="mt-2.5 space-y-5">
              {showMealRecommendations && <PopularOnPlanList />}
              <OverviewWeightCard />
              {showMealRecommendations && <OurProteinFavouritesPlanList />}
              <ScienceBackedMessage classNames={{ container: "py-0" }} />
            </div>
          </div>
        </div>
      </SafeAreaContent>
    </IonPage>
  );
});
